<!-- 新房--详情--楼盘相册 -->
<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- 广告 -->
    <div style="height: 100px"></div>
    <div class="add">
      <div class="addBg"><img :src="advertInfo.image" class="img" @click="linkOut(advertInfo.url)" /></div>
    </div>
    <div class="current">
      <div class="item">
        <span class="font-color-gray">当前位置：首页 > 新房 > 楼盘相册 > </span>
        <span>{{houseDetailAll.name}}</span>
      </div>
    </div>
    <!-- 楼盘首页 -->
    <div class="saleDetail">
      <div class="title">
         <div :class="isIndex == index ? 'title-items' : 'title-item'" v-for="(item, index) in titleList" :key="index" @click="linkPage(item.url, 'id', id)">{{ item.typeName }}</div>
      </div>
    </div>
    <div class="albumItem" v-for="(item, index) in imgswList" :key="index" v-if="item.imageList.length > 0">
      <!-- 规划图 -->
      <div class="albums">
        <div class="albums-l">{{item.typeName}}</div>
        <div class="activities-r">
          <div class="more" @click="linkBuildImgType(item.albumType)">
            查看更多 >
          </div>
        </div>
      </div>
      <div class="albumsImg" @click="showDetail(item)">
        <div class="albumsItem" v-for="(items, indexs) in item.imageList.slice(0,4)" :key="indexs" >
          <div class="imgItem">
            <img :src="items.image" alt="" class="imgsw" >
          </div>
          <div class="albumsName">
            {{items.name}}
          </div>
        </div>
      </div>
    </div>


    <!-- 楼盘推荐 -->
    <div class="recommend">
      <div class="t flex-b-c">
        <div>楼盘推荐</div>
        <!-- 导航按钮 -->
        <div class="flex-c-c swiper-button-group">
          <div class="btnswiper next next-gray flex-c-c" v-if="flag1"><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper next next-green flex-c-c" v-else><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper prev prev-gray flex-c-c" v-if="flag"><img src="../../../static/pC/prev-1.png" /></div>
          <div class="btnswiper prev prev-green flex-c-c" v-else><img src="../../../static/pC/prev-1.png" /></div>
        </div>
      </div>

      <div class="swiper-container card-carousel-cards">
        <div class="swiper-wrapper">
          <div class="swiper-slide card-carousel--card" v-for="(item, index) in recommendList" :key="index" @click="linkPage('/jobDetail', 'id', item.id)">
            <img :src="item.avatar" />
            <div class="n">{{ item.name }}</div>
            <div class="money">{{ item.price }}元/㎡</div>
          </div>
        </div>
      </div>
    </div>


    <!-- 相册详情 -->
    <div class="resume" v-show="showAgreement">
      <div class="mask" v-show="showAgreement"></div>
      <div class="resumeBox" v-show="showAgreement">
      	<div class="close">
          <img @click="closeShowAgreement()" src="../../../static/pC/cha-1.png"/>
        </div>
        <div class="">
          <div class="agreement">
            <div  class="salesImg" v-for="(item, index) in houseDetail" :key="'A'+ index">
              <img :src="item.image"  v-show="index == leftIndex"  style="width: 100%;height: 380PX;">
            </div>
            <div class="swiper-container card-carousel-cardes">
              <div class="swiper-wrapper">
                <div class="swiper-slide card-carousel-carde" style="width: 160px;height: 120px;" :class="leftIndex == index?'littles':'little'" v-for="(item,index) in houseDetail" :key="'B' + index" @click="clickImg(index)">
                  <img :src="item.image" alt="" class="img">
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    </div>



    <!-- 右侧导航 -->
    <RightNav></RightNav>

    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from "../../components/HeaderNav";
import FooterNav from "../../components/FooterNav";
import Banners from "../../components/Banners.vue";
import RightNav from '../../components/RightNav.vue';
import { getEstateAlbum, apiGetCity, apiAddNotes } from "../../api/job.js";
export default {
  name: "Index",
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banners: Banners,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: {  },
      id:'',
      isIndex:2,
      isImg:0,
      leftIndex:0,
      showAgreement:false,
      titleList: [
        { typeName: '楼盘首页', url: '/jobDetail' },
        { typeName: '楼盘详情', url: '/SaleDetail' },
        { typeName: '楼盘相册', url: '/BuildImg' },
        { typeName: '户型介绍', url: '/HouseType' },
        { typeName: '用户点评', url: '/evaluate' },
        // { typeName: '周边配套', url: '' },
        { typeName: '楼盘动态', url: '/Dynamics' }
      ],
      houseDetail:[],
      imgswList:[],
      recommendList:{},
      houseDetailAll:{},

      flag: false, //导航按钮是否到最末尾
      flag1: true, //导航按钮是否到最开头

      login: false, //是否登录
      userInfo: [] //是否登录--用户信息
    };
  },
  created(options) {
    this.id = this.$route.query.id;
    this.houseDetailAll = JSON.parse(sessionStorage.getItem('houseDetail'));
    this.judgeLogin();
    this.getIndex()
    this.getImg()
  },
  methods: {
    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },

    getIndex(){
      this.$loading();
      let  _this = this
      apiGetCity({
        id:this.id,
      }).then((res) => {
        this.advertInfo = res.data.advertInfo
        this.recommendList = res.data.recommendList;
        this.$nextTick(() => {
        //等页面刷新完之后，再执行回调函数中的方法
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 4,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: '.prev',
            prevEl: '.next'
          },
          on: {
            slideChangeTransitionEnd: function() {
              if (this.isEnd) {
                _this.flag = true;
              } else {
                _this.flag = false;
              }
              if (this.isBeginning) {
                _this.flag1 = true;
              } else {
                _this.flag1 = false;
              }
            }
          }
        });
        });
        this.$loading().close();
      })
        .catch((err) => {
          this.$loading().close();
        });
    },

    getImg(){
      this.$loading();
      getEstateAlbum({
        id:this.id,
        albumType:'',
        limit:4,
        page:1,
        type: 'pc'
      }).then((res) => {
        this.imgswList = res.data.list
        this.$loading().close();
      })
        .catch((err) => {
          this.$loading().close();
        });
    },
    showDetail(item){
      this.houseDetail = item.imageList
      console.log(item.imageList)
      this.showAgreement=true
    },
    linkImg(index){
      this.isImg = index
    },
    clickImg(index) {
      this.leftIndex = index;
    },
    //关闭协议
    closeShowAgreement(){
       this.showAgreement = false
    },
    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: url, query: { id: key }},  onComplete => {}, onAbort => {});
      }
    },

    //跳转到图片类型
    linkBuildImgType(type){
      let type1 = type
      let t = this
      this.$router.push({ path: '/BuildImgType', query: { id: t.id, type: type1  } });
    },
    
    
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
  }
};
</script>
<style scoped>
/* 广告 */
.add {
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
}
.addBg {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.addBg .img {
  width: 100%;
}
/* 当前 */
.current {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
  margin-top: 30px;
  border-bottom: 1px solid #e5e5e5;
}
.current .item {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 14px;
}
/* 楼盘详情 */.saleDetail{
  max-width: 1200px;
  margin: 30px  auto 0 auto;
  display: flex;
}
.saleDetail .title{
  width: 100%;
  background-color: #345c4e;
  color: #fff;
  display: flex;
  align-items: center;
  height: 50px;;
}
.saleDetail .title .title-item{
  width: 130px;
  text-align: center;
  cursor: pointer;
}
.saleDetail .title .title-items{
  width: 130px;
  text-align: center;
  background-color: #A98C60;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}
/* 全部图片 */
.saleImg{
  max-width: 1200px;
  margin: 30px  auto 0 auto;
  display: flex;
}
.saleImg .title-img{
  width: 100%;

  display: flex;
  align-items: center;
  height: 50px;;
}
.saleImg .title-img .img-item{
  padding: 0 20px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  border-radius: 20px;
  background-color: #e5e5e5;
  font-size: 16px;
  margin-right: 20px;
}
.saleImg .title-img .img-items{
  padding: 0 20px;
  text-align: center;
  background-color: #345c4e;
  border-radius: 20px;
  color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  margin-right: 20px;
}
/* 规划图 */
.albumItem{
  width: 1200px;
  margin: 30px auto 20px auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.albums{
  width: 1200px;
  margin: 30px auto 20px auto;
  display: flex;
  justify-content: space-between;
}
.albums-l{
  font-size: 20px;
  font-weight: bold;
}
.activities-r{
  display: flex;
}
.activities-l{
  display: flex;
  color: #345C4E;
  font-size: 15px;
}
.more{
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.xian{
  margin: 0 20px;
}

.albumsImg{
  width: 1200px;
  margin: 0  auto;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}

.albumsItem{
  width: 24%;
  padding: 0;
  text-align: center;
  margin-right: 25px;
}
.imgItem{
  width: 280px;
  height: 220px;
}
.imgItems{
  width: 280px;
  height: 280px;
  border: 1px solid #e5e5e5;
}
.imgsw{
  width: 100%;
  height: 100%;
}
.albumsName{
  margin-top: 20px;
}
.albumsNames{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
/* 楼盘推荐 */
.recommend {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;
}
.recommend .t {
  width: 100%;
  font-size: 22px;
  font-weight: bold;
}
.recommend .swiper-button-group {
}
.recommend .swiper-button-group .btnswiper {
  width: 30px;
  height: 30px;
}
.recommend .swiper-button-group .btnswiper img {
  width: 12px;
  height: 20px;
}
.recommend .swiper-button-group .prev {
  margin-left: 20px;
}
.recommend .swiper-button-group .next-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .next-green {
  background: #345c4e;
}
.recommend .swiper-button-group .prev-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .prev-green {
  background: #345c4e;
}
.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}
.card-carousel-cards .card-carousel--card {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  max-width: 100%;
  height: 227px;
  vertical-align: bottom;
  display: flex;
}

.card-carousel-cards .card-carousel--card .n {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
.card-carousel-cards .card-carousel--card .money {
  font-size: 16px;
  font-weight: bold;
  color: #345c4e;
  margin-top: 20px;
}

/* 登录弹窗 */
.resume {
  width: 100%;
  height: 100%;
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.resumeBox {
  position: fixed;
  width: 700px;
  background: #333;
  /* border: 1px solid #ccc; */
  text-align: center;
  top: calc(50% - 250px);
  left: calc(50% - 350px);
  min-height: 572px;
  border-radius: 10px;
  z-index: 9999
}
.resumeBox .close {
  margin-right: -15px;
  margin-top: -15px;
}
.resumeBox .close img{
  width: 35px;
  height: 35px;
}
.resumeBox .t{
  font-size: 36px;
  font-weight: bold;
  color: #345C4E;
  width: 100%;
  text-align: center;
  margin-top: 60px;
  padding-left: 50px;
}
.resumeBox .line{
  width: 75%;
  height: 2px;
  background-color: #345C4E;
  margin-top: 20px;
}
.resumeBox .detail{
  padding: 0 70px;
  margin-top: 50px;
}
.resumeBox .detail .box{
  width: 100%;
  line-height: 60px;
  margin-top: 20px;
  border-bottom: 1px solid #EEEEEE;
}
.resumeBox .detail .box .left img{
  width: 34px;
  height: 34px;
  margin-right: 15px;
}
.resumeBox .detail .box input{
  padding-right: 20px;
}
.resumeBox .detail .box input{
  padding-right: 20px;
}
.resumeBox .detail .box .code{
  cursor: pointer;
}
.resumeBox .submit{
  width: 100%;
  height: 60px;
  background: #345C4E;
  border-radius: 10px;
  font-size: 24px;
  color: #FFFFFF;
  margin-top: 30px;
  cursor: pointer;
}
.resumeBox .radio-box{
  margin-top: 25px;
  text-align: left;
}
.resumeBox .radio-box .tk{
  margin-left: 10px;
  font-size: 16px;
  color: #345C4E;
}
.resumeBox .radio-box .tk .tb{
 font-size: 16px;
 color: #333333;
}
.card-carousel-cardes {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 25px;
}

.card-carousel-cardes .card-carousel-carde {
  cursor: pointer;
  /* background-color: #fff; */
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.card-carousel-cardes .card-carousel-carde:hover {
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
}
.card-carousel-cardes .card-carousel-carde:first-child {
  margin-left: 0;
}
.card-carousel-cardes .card-carousel-carde:last-child {
  margin-right: 0;
}
.card-carousel-cardes .card-carousel-carde img {
  max-width: 100%;
  height: 120px;
  vertical-align: bottom;
  display: flex;
  width: 90%;
  /* margin-right: 20px; */
}
.card-carousel-cardes .card-carousel-carde img:hover {
  opacity: 0.5;
}

/* 协议内容弹窗 */
.agreement {
  /* width: 450px; */
  width: 94%;
  height: 380px;
  margin: 20px auto 0 auto;
  border: 1px solid #A4A8BB;
}
</style>



// WEBPACK FOOTER //
// src/view/Job/BuildImg.vue